import { RoutePermissionGate } from "components/layout/AccessControl";
import AuthLayout from "components/layout/AuthLayout";
import Layout from "components/layout/Layout";
import UiKitLayout from "components/layout/UiKitLayout";
import Loadable from "lib/suspenseLoader/Loadable";
import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

import { PATHS } from "configs/routeConfig";

import GuestRoute from "./GuestRoutes";
import PrivateRoute from "./PrivateRoutes";

/** Auth */
const Login = Loadable(lazy(() => import("modules/auth/login/Login")));
const DeleteUser = Loadable(
  lazy(() => import("modules/deleteUser/DeleteUser"))
);

const Registration = Loadable(
  lazy(() => import("modules/auth/registration/Registration"))
);
const ForgotPassword = Loadable(
  lazy(() => import("modules/auth/forgotPassword/ForgotPassword"))
);
const ResetPassword = Loadable(
  lazy(() => import("modules/auth/resetPassword/ResetPassword"))
);

/** Dashboard */
const Dashboard = Loadable(lazy(() => import("modules/dashboard/Dashboard")));
const AddDashboardPost = Loadable(
  lazy(() => import("modules/dashboard/AddPost"))
);
/** User Management*/
const UserManagement = Loadable(
  lazy(() => import("modules/userManagement/UserManagement"))
);
const UserList = Loadable(
  lazy(() => import("modules/userManagement/userList/UserList"))
);

const WorkerList = Loadable(
  lazy(() => import("modules/userManagement/workerUsers/WorkerList"))
);

const AssignAddWorker = Loadable(
  lazy(() => import("modules/userManagement/workerUsers/AssignAddWorker"))
);

const UserDetails = Loadable(
  lazy(() => import("modules/userManagement/userDetails/ViewUserDetails"))
);

/** Statistics Management*/

const Statistics = Loadable(
  lazy(() => import("modules/statistics/Statastics"))
);

const WorkerStatistics = Loadable(
  lazy(() => import("modules/statistics/WorkerStatistics"))
);

const WorkerStatisticsReport = Loadable(
  lazy(() => import("modules/statistics/WorkerStatisticsReport"))
);

/** Content Management*/
const ContentManagement = Loadable(
  lazy(() => import("modules/contentManagement/ContentManagement"))
);
const StaticPages = Loadable(
  lazy(() => import("modules/contentManagement/staticPages/StaticPages"))
);
const StatisPagesViewDetails = Loadable(
  lazy(() =>
    import("modules/contentManagement/staticPages/ViewStaticPageDetails")
  )
);
const AddStaticPage = Loadable(
  lazy(() =>
    import(
      "modules/contentManagement/staticPages/StaticPagesActions/AddStaticPage"
    )
  )
);
const BlogsPage = Loadable(
  lazy(() => import("modules/contentManagement/blogs/Blogs"))
);
const BlogList = Loadable(
  lazy(() => import("modules/contentManagement/blogs/blogList/BlogList"))
);
const AddBlog = Loadable(
  lazy(() =>
    import("modules/contentManagement/blogs/blogList/BlogActions/AddBlog")
  )
);
const ViewBlogDetails = Loadable(
  lazy(() =>
    import(
      "modules/contentManagement/blogs/blogList/BlogActions/ViewBlogDetails"
    )
  )
);

const BlogCategory = Loadable(
  lazy(() =>
    import("modules/contentManagement/blogs/blogCategory/BlogCategory")
  )
);
const AddCategory = Loadable(
  lazy(() =>
    import(
      "modules/contentManagement/blogs/blogCategory/BlogCategoryActions/AddCategory"
    )
  )
);
const FaqsPage = Loadable(
  lazy(() => import("modules/contentManagement/faq/Faq"))
);
const FaqsList = Loadable(
  lazy(() => import("modules/contentManagement/faq/faqList/FaqsList"))
);
const AddFaq = Loadable(
  lazy(() => import("modules/contentManagement/faq/faqList/faqActions/AddFaq"))
);
const FaqsCategory = Loadable(
  lazy(() => import("modules/contentManagement/faq/faqCategory/FaqCategory"))
);
const AddFaqCategory = Loadable(
  lazy(() =>
    import(
      "modules/contentManagement/faq/faqCategory/faqActions/AddFaqCategory"
    )
  )
);

/** Role */
const RoleManagement = Loadable(
  lazy(() => import("modules/role/RoleManagement"))
);
const RolePage = Loadable(lazy(() => import("modules/role/Role")));
const AddEditRole = Loadable(lazy(() => import("modules/role/AddEditRole")));
const ViewRole = Loadable(lazy(() => import("modules/role/ViewRole")));

/** Email And Notifications */
const EmailTemplatesManagement = Loadable(
  lazy(() => import("modules/emailTemplates/EmailTemplatesManagement"))
);
const EmailTemplates = Loadable(
  lazy(() => import("modules/emailTemplates/EmailTemplates"))
);
const AddEditTemplates = Loadable(
  lazy(() => import("modules/emailTemplates/AddEditTemplates"))
);
const ViewTemplates = Loadable(
  lazy(() => import("modules/emailTemplates/ViewTemplates"))
);

/** Master Management */
const MasterManagement = Loadable(
  lazy(() => import("modules/masterManagement/MasterManagement"))
);
const CityPage = Loadable(
  lazy(() => import("modules/masterManagement/city/Cities"))
);
const AddEditCity = Loadable(
  lazy(() => import("modules/masterManagement/city/AddEditCity"))
);
const ZonePage = Loadable(
  lazy(() => import("modules/masterManagement/zone/Zones"))
);
const AddEditZonesPage = Loadable(
  lazy(() => import("modules/masterManagement/zone/AddEditZones"))
);
const ClubTypePage = Loadable(
  lazy(() => import("modules/masterManagement/clubType/ClubType"))
);
const AddEditClubTypePage = Loadable(
  lazy(() => import("modules/masterManagement/clubType/AddEditClubType"))
);

const MusicTypePage = Loadable(
  lazy(() => import("modules/masterManagement/musicType/MusicType"))
);
const AddEditMusicTypePage = Loadable(
  lazy(() => import("modules/masterManagement/musicType/AddEditMusicType"))
);

const DrinkTypePage = Loadable(
  lazy(() => import("modules/masterManagement/drinkType/DrinkType"))
);
const AddEditDrinkTypePage = Loadable(
  lazy(() => import("modules/masterManagement/drinkType/AddEditDrinkType"))
);

const PlanPage = Loadable(
  lazy(() => import("modules/masterManagement/plan/Plan"))
);

const AddEditPlansPage = Loadable(
  lazy(() => import("modules/masterManagement/plan/AddEditPlans"))
);
const OutfitPage = Loadable(
  lazy(() => import("modules/masterManagement/outfits/Outfits"))
);

const AddEditOutfitPage = Loadable(
  lazy(() => import("modules/masterManagement/outfits/AddEditOutFits"))
);

const AddLanguage = Loadable(
  lazy(() => import("modules/masterManagement/language/AddLanguage"))
);

const LanguagePage = Loadable(
  lazy(() => import("modules/masterManagement/language/Language"))
);
/** Clubs  */
const ClubsManagement = Loadable(
  lazy(() => import("modules/clubs/ClubManagement"))
);

const ClubsListPage = Loadable(
  lazy(() => import("modules/clubs/clubList/Clubs"))
);

const AdminClubDetailPage = Loadable(
  lazy(() =>
    import(
      "modules/clubs/supperAdminClubManagement/adminClubDetails/AdminClubDetails"
    )
  )
);
const ClubAdminDetailsPage = Loadable(
  lazy(() => import("modules/clubs/clubDetails/ViewClubDetails"))
);

const ClubAddEditPage = Loadable(
  lazy(() =>
    import(
      "modules/clubs/supperAdminClubManagement/superAdminClub/AddEditClubs"
    )
  )
);

// const WeekProvider = Loadable(
//   lazy(() =>
//     import(
//       "modules/clubs/supperAdminClubManagement/superAdminClub/ClubWeekProvider"
//     )
//   )
// );

const ClubsPostsListPage = Loadable(
  lazy(() => import("modules/clubs/clubsPost/ClubsPostsList"))
);
const AddEditClubsPostsPage = Loadable(
  lazy(() => import("modules/clubs/clubsPost/AddEditClubsPosts"))
);

/** Support */
const SupportManagement = Loadable(
  lazy(() => import("modules/support/SupportManagement"))
);
const Support = Loadable(lazy(() => import("modules/support/Support")));
const TicketDetail = Loadable(
  lazy(() => import("modules/support/TicketDetails"))
);
/** Settings */
const Settings = Loadable(lazy(() => import("modules/settings/Settings")));
const GeneralSettings = Loadable(
  lazy(() => import("modules/settings/generalSettings/GeneralSettings"))
);
const EmailNotifications = Loadable(
  lazy(() => import("modules/settings/emailNotifications/EmailNotifications"))
);
const PaymentGateway = Loadable(
  lazy(() => import("modules/settings/paymentGateway/PaymentGateway"))
);
const SmtpSmsDetails = Loadable(
  lazy(() => import("modules/settings/smtpSmsDetails/SmtpSmsDetails"))
);
const SocialMedia = Loadable(
  lazy(() => import("modules/settings/socialMedial/SocialMedia"))
);
const LanguageMessages = Loadable(
  lazy(() => import("modules/settings/langaugePreferences/LanguageMessages"))
);
const AddLanguageMessages = Loadable(
  lazy(() => import("modules/settings/langaugePreferences/AddLanguageMessage"))
);
const LangaugeStaticLang = Loadable(
  lazy(() => import("modules/settings/langaugePreferences/LanguageStaticLang"))
);
const AddLanguageStaticLang = Loadable(
  lazy(() => import("modules/settings/langaugePreferences/AddStaticLabel"))
);
/** Master Management */
// const CommonPages = Loadable(lazy(() => import("modules/commonPages/CommonPages")));
const FourZeroFourPage = Loadable(
  lazy(() => import("modules/commonPages/FourZeroFourPage"))
);
const ThankyouPage = Loadable(
  lazy(() => import("modules/commonPages/ThankyouPage"))
);
const ComingSoonPage = Loadable(
  lazy(() => import("modules/commonPages/ComingSoonPage"))
);

/** My Profile */
const MyProfile = Loadable(lazy(() => import("modules/myProfile/MyProfile")));
const EditMyProfile = Loadable(
  lazy(() => import("modules/myProfile/EditProfile"))
);

/** Change Password */
const ChangePasswordPage = Loadable(
  lazy(() => import("modules/changePassword/ChangePassword"))
);

/** Category */
const CategoryManagement = Loadable(
  lazy(() => import("modules/category/Category"))
);
const LevelsPage = Loadable(
  lazy(() => import("modules/category/levels/Levels"))
);
const AddEditLevelsPage = Loadable(
  lazy(() => import("modules/category/levels/AddEditLevels"))
);

const SuperLevelsPage = Loadable(
  lazy(() => import("modules/category/superLevels/superLevels"))
);
const AddEditSuperLevelsPage = Loadable(
  lazy(() => import("modules/category/superLevels/AddEditSuperLevels"))
);
const BenefitsPage = Loadable(
  lazy(() => import("modules/category/benefits/Benefits"))
);
const AddEditBenefitsPage = Loadable(
  lazy(() => import("modules/category/benefits/AddeditBenefits"))
);
const ActionsPage = Loadable(
  lazy(() => import("modules/category/actions/Actions"))
);
const AddEditActions = Loadable(
  lazy(() => import("modules/category/actions/AddEditActions"))
);
const ClubAdminAddEditActions = Loadable(
  lazy(() => import("modules/category/actions/ClubAdminAddAction"))
);
const AdminsAddEditBenefitsPage = Loadable(
  lazy(() => import("modules/category/benefits/AdminsAddEditBenefits"))
);
const ManagePointsPage = Loadable(
  lazy(() => import("modules/category/actions/ManagePoints"))
);
const ManageBenefitsPage = Loadable(
  lazy(() => import("modules/category/benefits/ManageBenefits"))
);
const AtmosphereRangesPage = Loadable(
  lazy(() => import("modules/category/atmosphereRanges/AtmosphereRanges"))
);
const AddEditAtmosphereRanges = Loadable(
  lazy(() =>
    import("modules/category/atmosphereRanges/AddEditAtmosphereRenges")
  )
);
const QueTypePage = Loadable(
  lazy(() => import("modules/category/queType/QueType"))
);
const AddEditQueTypePage = Loadable(
  lazy(() => import("modules/category/queType/AddEditQueType"))
);
const GenderPage = Loadable(
  lazy(() => import("modules/category/gender/Gender"))
);
const EditGenderPage = Loadable(
  lazy(() => import("modules/category/gender/EditGender"))
);
/** Brands  */
const BrandsManagement = Loadable(
  lazy(() => import("modules/brand/BrandManagement"))
);
const BrandListingPage = Loadable(
  lazy(() => import("modules/brand/brandList/BrandList"))
);
const BrandsPostListPage = Loadable(
  lazy(() => import("modules/brand/brandpost/BrandPost"))
);
const AddEditBrandPostPage = Loadable(
  lazy(() => import("modules/brand/brandpost/AddEditBrandPost"))
);
const BrandsSurveyListPage = Loadable(
  lazy(() => import("modules/brand/brandSurvey/BrandSurvey"))
);
const AddEditBrandSurveyPage = Loadable(
  lazy(() => import("modules/brand/brandSurvey/AddEditBrandSurvey"))
);
const AddEditBrandPage = Loadable(
  lazy(() => import("modules/brand/addEditBrand/AddEditBrand"))
);
const BrandDetailsPage = Loadable(
  lazy(() => import("modules/brand/brandDetails/BrandDetails"))
);

const BrandAdminDetailsPage = Loadable(
  lazy(() => import("modules/brand/brandAdminDetails/brandAdminDeatils"))
);
const PromotionManagement = Loadable(
  lazy(() => import("modules/managePromotion/ManagePromotion"))
);
const PromotionListPage = Loadable(
  lazy(() => import("modules/managePromotion/Promotion"))
);
const AddNewPromotionPage = Loadable(
  lazy(() => import("modules/managePromotion/AddPromotions"))
);
const EditAdminPromotions = Loadable(
  lazy(() => import("modules/managePromotion/EditAdminPromotions"))
);
const PromotionDetailsPage = Loadable(
  lazy(() => import("modules/managePromotion/PromotionDetails"))
);
const SuperAdmminReports = Loadable(
  lazy(() => import("modules/superAdminReports/SuperAdminReportsManagement"))
);
const AdminMonitoringReportPage = Loadable(
  lazy(() => import("modules/superAdminReports/AdminMonitoring"))
);
const UserReportPage = Loadable(
  lazy(() => import("modules/superAdminReports/UserReports"))
);
const ClubReportPage = Loadable(
  lazy(() => import("modules/superAdminReports/ClubReports"))
);
const BrandReportPage = Loadable(
  lazy(() => import("modules/superAdminReports/BrandReports"))
);

const BrandSubscriberList = Loadable(
  lazy(() => import("modules/brand/brandSubscriberList/BrandSubscriberList"))
);

const ClubStatsDetailsPage = Loadable(
  lazy(() => import("modules/superAdminReports/ClubStatsDetails"))
);
const BrandStatsDeatilsPage = Loadable(
  lazy(() => import("modules/superAdminReports/BrandStatsDetails"))
);
const ClubAdminReportPage = Loadable(
  lazy(() => import("modules/clubAdminReports/ClubAdminReports"))
);
const ClubMonitoringReports = Loadable(
  lazy(() => import("modules/clubAdminReports/ClubMonitoring"))
);
const ClubUserReports = Loadable(
  lazy(() => import("modules/clubAdminReports/ClubUsersReport"))
);
const BrandMonitoringReports = Loadable(
  lazy(() => import("modules/brandAdminReports/BrandMonitoring"))
);
const BrandUserReports = Loadable(
  lazy(() => import("modules/brandAdminReports/BrandUsersReports"))
);
const BrandReportManagement = Loadable(
  lazy(() => import("modules/brandAdminReports/BrandAdminReports"))
);
const AdminUsers = Loadable(
  lazy(() => import("modules/userManagement/adminUsers/AdminUsers"))
);
// const AddUser = Loadable(
//   lazy(() => import("modules/userManagement/userList/AddUser"))
// );
const AdminUserDetails = Loadable(
  lazy(() => import("modules/userManagement/adminUsers/ViewAdminUserDetails"))
);
const AdminUserAdd = Loadable(
  lazy(() => import("modules/userManagement/adminUsers/AddEditAdminUser"))
);
const AdminUserEdit = Loadable(
  lazy(() => import("modules/userManagement/adminUsers/AddEditAdminUser"))
);
/** UI Kit */
const UiKit = Loadable(lazy(() => import("modules/uiKit/UiKit")));
const UiTypography = Loadable(
  lazy(() => import("modules/uiKit/uiComponents/UiTypograpgy"))
);
const UiColors = Loadable(
  lazy(() => import("modules/uiKit/uiComponents/UiColors"))
);
const UiForms = Loadable(
  lazy(() => import("modules/uiKit/uiComponents/UiForms"))
);
const UiCards = Loadable(
  lazy(() => import("modules/uiKit/uiComponents/UiCards"))
);
const UiBlocks = Loadable(
  lazy(() => import("modules/uiKit/uiComponents/UiBlocks"))
);

const MainRoutes = {
  path: PATHS.DEFAULT,
  element: (
    <PrivateRoute>
      <Layout />
    </PrivateRoute>
  ),
  children: [
    // Dashboard
    {
      path: PATHS.DASHBOARD,
      element: <Dashboard />,
    },
    {
      path: PATHS.DASHBOARD + PATHS?.ADD_POST,
      element: <AddDashboardPost />,
    },
    // User management
    {
      path: PATHS.USER,
      element: <UserManagement />,
      children: [
        {
          // index: true,
          path: PATHS.USER_LIST,
          element: (
            <RoutePermissionGate>
              <UserList />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.USER + "/" + PATHS.USER_LIST + "/" + PATHS.VIEW + "/:id",
          element: (
            <RoutePermissionGate>
              <UserDetails type="view" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.USER + "/" + PATHS.USER_LIST + "/" + PATHS.WORKER + "/:id",
          element: (
            <RoutePermissionGate>
              <UserDetails type="worker" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.ADMIN_USER,
          element: (
            <RoutePermissionGate>
              <AdminUsers />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.ADMIN_USER + "/" + PATHS.VIEW + "/:id",
          element: (
            <RoutePermissionGate>
              <AdminUserDetails type="view" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.ADMIN_USER + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AdminUserAdd type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.ADMIN_USER + "/" + PATHS.EDIT + "/:id",
          element: (
            <RoutePermissionGate>
              <AdminUserEdit type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.USER + "/" + PATHS.WORKER_LIST,
          element: (
            <RoutePermissionGate>
              <WorkerList />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.USER + "/" + PATHS.WORKER_LIST + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AssignAddWorker type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.USER + "/" + PATHS.WORKER_LIST + "/" + PATHS.EDIT + "/:id",
          element: (
            <RoutePermissionGate>
              <AssignAddWorker type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.USER + "/" + PATHS.WORKER_LIST + "/" + PATHS.WORKER + "/:id",
          element: (
            <RoutePermissionGate>
              <AssignAddWorker type="worker" />
            </RoutePermissionGate>
          ),
        },

        {
          path: "",
          element: <Navigate to={`${PATHS.USER}/${PATHS.USER_LIST}`} />,
        },
        {
          path: PATHS.ANY,
          element: <Navigate to={`${PATHS.USER}/${PATHS.USER_LIST}`} />,
        },
      ],
    },

    // Statistics
    {
      path: PATHS.STATISTICS,
      element: <Statistics />,
      children: [
        {
          path: PATHS.WORKER_STATISTICS,
          element: <WorkerStatistics />,
        },
        {
          path: PATHS.WORKER_STATISTICS_REPORT,
          element: <WorkerStatisticsReport />,
        },
      ],
    },

    // Content management
    {
      path: PATHS.CONTENT,
      element: <ContentManagement />,
      children: [
        // Static Pages
        {
          path: PATHS.STATIC_PAGES,
          element: (
            <RoutePermissionGate>
              <StaticPages />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.STATIC_PAGES + "/" + PATHS.VIEW,
          element: (
            <RoutePermissionGate>
              <StatisPagesViewDetails />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.STATIC_PAGES + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddStaticPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.STATIC_PAGES + "/" + PATHS.EDIT,
          element: (
            <RoutePermissionGate>
              <AddStaticPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        // Blogs
        {
          path: PATHS.BLOGS,
          element: <BlogsPage />,
          children: [
            {
              path: PATHS.BLOG_LIST,
              element: (
                <RoutePermissionGate>
                  <BlogList />
                </RoutePermissionGate>
              ),
            },
            {
              path: PATHS.BLOG_LIST + "/" + PATHS.VIEW,
              element: (
                <RoutePermissionGate>
                  <ViewBlogDetails />
                </RoutePermissionGate>
              ),
            },
            {
              path: PATHS.BLOG_LIST + "/" + PATHS.CREATE,
              element: (
                <RoutePermissionGate>
                  <AddBlog type="add" />
                </RoutePermissionGate>
              ),
            },
            {
              path: PATHS.BLOG_LIST + "/" + PATHS.EDIT,
              element: (
                <RoutePermissionGate>
                  <AddBlog type="edit" />
                </RoutePermissionGate>
              ),
            },
            {
              path: PATHS.BLOG_CATEGORY,
              element: (
                <RoutePermissionGate>
                  <BlogCategory />
                </RoutePermissionGate>
              ),
            },
            {
              path: PATHS.BLOG_CATEGORY + "/" + PATHS.CREATE,
              element: (
                <RoutePermissionGate>
                  <AddCategory type="add" />
                </RoutePermissionGate>
              ),
            },
            {
              path: PATHS.BLOG_CATEGORY + "/" + PATHS.EDIT,
              element: (
                <RoutePermissionGate>
                  <AddCategory type="edit" />
                </RoutePermissionGate>
              ),
            },
            {
              path: "",
              element: (
                <Navigate
                  to={`${PATHS.CONTENT}/${PATHS.BLOGS}/${PATHS.BLOG_LIST}`}
                />
              ),
            },
            {
              path: PATHS.ANY,
              element: (
                <Navigate
                  to={`${PATHS.CONTENT}/${PATHS.BLOGS}/${PATHS.BLOG_LIST}`}
                />
              ),
            },
          ],
        },
        // Faqs
        {
          path: PATHS.FAQS,
          element: <FaqsPage />,
          children: [
            {
              path: PATHS.FAQS_LIST,
              element: (
                <RoutePermissionGate>
                  <FaqsList />
                </RoutePermissionGate>
              ),
            },
            {
              path: PATHS.FAQS_LIST + "/" + PATHS.EDIT,
              element: (
                <RoutePermissionGate>
                  <AddFaq type="edit" />
                </RoutePermissionGate>
              ),
            },
            {
              path: PATHS.FAQS_LIST + "/" + PATHS.CREATE,
              element: (
                <RoutePermissionGate>
                  <AddFaq type="add" />
                </RoutePermissionGate>
              ),
            },
            {
              path: PATHS.FAQS_CATEGORY,
              element: (
                <RoutePermissionGate>
                  <FaqsCategory />
                </RoutePermissionGate>
              ),
            },
            {
              path: PATHS.FAQS_CATEGORY + "/" + PATHS.CREATE,
              element: (
                <RoutePermissionGate>
                  <AddFaqCategory type="add" />
                </RoutePermissionGate>
              ),
            },
            {
              path: PATHS.FAQS_CATEGORY + "/" + PATHS.EDIT,
              element: (
                <RoutePermissionGate>
                  <AddFaqCategory type="edit" />
                </RoutePermissionGate>
              ),
            },
            {
              path: "",
              element: (
                <Navigate
                  to={`${PATHS.CONTENT}/${PATHS.FAQS}/${PATHS.FAQS_LIST}`}
                />
              ),
            },
            {
              path: PATHS.ANY,
              element: (
                <Navigate
                  to={`${PATHS.CONTENT}/${PATHS.FAQS}/${PATHS.FAQS_LIST}`}
                />
              ),
            },
          ],
        },
        {
          path: "",
          element: <Navigate to={`${PATHS.CONTENT}/${PATHS.STATIC_PAGES}`} />,
        },
        {
          path: PATHS.ANY,
          element: <Navigate to={`${PATHS.CONTENT}/${PATHS.STATIC_PAGES}`} />,
        },
      ],
    },

    // Role
    {
      path: PATHS.ROLE,
      element: <RoleManagement />,
      children: [
        {
          path: "",
          element: (
            <RoutePermissionGate>
              <RolePage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditRole type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.EDIT + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <AddEditRole type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.VIEW + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <ViewRole type="view" />
            </RoutePermissionGate>
          ),
        },
      ],
    },
    // Email And Notifications
    {
      path: PATHS.EMAIL_TEMPLATES,
      element: <EmailTemplatesManagement />,
      children: [
        {
          path: "",
          element: (
            <RoutePermissionGate>
              <EmailTemplates />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditTemplates type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.EDIT,
          element: (
            <RoutePermissionGate>
              <AddEditTemplates type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.VIEW,
          element: (
            <RoutePermissionGate>
              <ViewTemplates type="view" />
            </RoutePermissionGate>
          ),
        },
      ],
    },
    // Master Management
    {
      path: PATHS.MASTER_MANAGEMENT,
      element: <MasterManagement />,
      children: [
        {
          path: PATHS.CITIES,
          element: (
            <RoutePermissionGate>
              <CityPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.MASTER_MANAGEMENT + PATHS.CITIES + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditCity type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.MASTER_MANAGEMENT +
            "/" +
            PATHS.CITIES +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditCity type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.ZONES,
          element: (
            <RoutePermissionGate>
              <ZonePage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.MASTER_MANAGEMENT + PATHS.ZONES + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditZonesPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.MASTER_MANAGEMENT +
            "/" +
            PATHS.ZONES +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditZonesPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CLUB_TYPE,
          element: (
            <RoutePermissionGate>
              <ClubTypePage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.MASTER_MANAGEMENT + PATHS.CLUB_TYPE + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditClubTypePage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.MASTER_MANAGEMENT +
            "/" +
            PATHS.CLUB_TYPE +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditClubTypePage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.DRINK_TYPE,
          element: (
            <RoutePermissionGate>
              <DrinkTypePage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.MASTER_MANAGEMENT + PATHS.DRINK_TYPE + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditDrinkTypePage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.MASTER_MANAGEMENT +
            "/" +
            PATHS.DRINK_TYPE +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditDrinkTypePage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.MUSIC_TYPE,
          element: (
            <RoutePermissionGate>
              <MusicTypePage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.MASTER_MANAGEMENT + PATHS.MUSIC_TYPE + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditMusicTypePage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.MASTER_MANAGEMENT +
            "/" +
            PATHS.MUSIC_TYPE +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditMusicTypePage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.OUTFITS,
          element: (
            <RoutePermissionGate>
              <OutfitPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.MASTER_MANAGEMENT + PATHS.OUTFITS + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditOutfitPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.MASTER_MANAGEMENT +
            "/" +
            PATHS.OUTFITS +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditOutfitPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.PLANS,
          element: (
            <RoutePermissionGate>
              <PlanPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.MASTER_MANAGEMENT + PATHS.PLANS + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditPlansPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.MASTER_MANAGEMENT +
            "/" +
            PATHS.PLANS +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditPlansPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.LANGUAGE,
          element: (
            <RoutePermissionGate>
              <LanguagePage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.LANGUAGE + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddLanguage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: "",
          element: <Navigate to={`${PATHS.MASTER_MANAGEMENT}/${PATHS.ci}`} />,
        },
        {
          path: PATHS.ANY,
          element: (
            <Navigate to={`${PATHS.MASTER_MANAGEMENT}/${PATHS.CITIES}`} />
          ),
        },
      ],
    },
    // brands
    {
      path: PATHS.BRAND,
      element: <BrandsManagement />,
      children: [
        {
          path: PATHS.BRAND,
          element: (
            <RoutePermissionGate>
              <BrandListingPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.BRAND + PATHS.EDIT + "/" + ":id" + "/" + ":url",
          element: (
            <RoutePermissionGate>
              <AddEditBrandPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.BRAND + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditBrandPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.BRAND + PATHS.BRAND_POSTS_LIST + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <BrandsPostListPage />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.BRAND +
            PATHS.BRAND_POSTS_LIST +
            "/" +
            PATHS.CREATE +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditBrandPostPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.BRAND +
            PATHS.BRAND_POSTS_LIST +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditBrandPostPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.BRAND + PATHS.BRAND_SURVEY_LIST + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <BrandsSurveyListPage />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.BRAND +
            PATHS.BRAND_SURVEY_LIST +
            "/" +
            PATHS.CREATE +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditBrandSurveyPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.BRAND +
            PATHS.BRAND_SURVEY_LIST +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditBrandSurveyPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.BRAND + PATHS.VIEW + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <BrandDetailsPage />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.BRAND +
            PATHS.BRAND_ADMIN_LIST +
            "/" +
            PATHS.VIEW +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <BrandAdminDetailsPage />
            </RoutePermissionGate>
          ),
        },
      ],
    },
    // category
    {
      path: PATHS.CATEGORY,
      element: <CategoryManagement />,
      children: [
        {
          path: PATHS.LEVELS,
          element: (
            <RoutePermissionGate>
              <LevelsPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CATEGORY + PATHS.LEVELS + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditLevelsPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CATEGORY + PATHS.LEVELS + "/" + PATHS.EDIT + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <AddEditLevelsPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CATEGORY + PATHS.LEVELS + "/" + PATHS.VIEW + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <AddEditLevelsPage type="view" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.SUPER_LEVELS,
          element: (
            <RoutePermissionGate>
              <SuperLevelsPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CATEGORY + PATHS.SUPER_LEVELS + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditSuperLevelsPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.CATEGORY +
            PATHS.SUPER_LEVELS +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditSuperLevelsPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.BENEFITS,
          element: (
            <RoutePermissionGate>
              <BenefitsPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CATEGORY + PATHS.BENEFITS + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditBenefitsPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.CATEGORY + PATHS.BENEFITS + "/" + PATHS.EDIT + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <AddEditBenefitsPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.CATEGORY + PATHS.BENEFITS + "/" + PATHS.VIEW + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <AddEditBenefitsPage type="view" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.ACTIONS,
          element: (
            <RoutePermissionGate>
              <ActionsPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CATEGORY + PATHS.ACTIONS + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditActions type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CATEGORY + PATHS.ACTIONS + "/" + PATHS.EDIT + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <AddEditActions type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CATEGORY + PATHS.ACTIONS + "/" + PATHS.VIEW + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <AddEditActions type="view" />
            </RoutePermissionGate>
          ),
        },

        {
          path: PATHS.ATMOSPHERE_RANGES,
          element: (
            <RoutePermissionGate>
              <AtmosphereRangesPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CATEGORY + PATHS.ATMOSPHERE_RANGES + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditAtmosphereRanges type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.CATEGORY +
            PATHS.ATMOSPHERE_RANGES +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditAtmosphereRanges type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.QUE_TYPE,
          element: (
            <RoutePermissionGate>
              <QueTypePage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.QUE_TYPE + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddEditQueTypePage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.QUE_TYPE + "/" + PATHS.EDIT + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <AddEditQueTypePage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.GENDER_MIX,
          element: (
            <RoutePermissionGate>
              <GenderPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.GENDER_MIX + "/" + PATHS.EDIT + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <EditGenderPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: "",
          element: <Navigate to={`${PATHS.CATEGORY}/${PATHS.LEVELS}`} />,
        },
        {
          path: PATHS.ANY,
          element: <Navigate to={`${PATHS.CATEGORY}/${PATHS.LEVELS}`} />,
        },
      ],
    },

    //manage points
    {
      path: PATHS.MANAGE_POINTS,
      element: <ManagePointsPage />,
      children: [
        {
          path: PATHS.ACTIONS,
          element: (
            <RoutePermissionGate>
              <ActionsPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.MANAGE_POINTS + "/" + PATHS.ACTIONS + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <ClubAdminAddEditActions type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.MANAGE_POINTS +
            PATHS.ACTIONS +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <ClubAdminAddEditActions type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.MANAGE_POINTS +
            PATHS.ACTIONS +
            "/" +
            PATHS.VIEW +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <ClubAdminAddEditActions type="view" />
            </RoutePermissionGate>
          ),
        },
      ],
    },

    // manage Benefits for club
    {
      path: PATHS.MANAGE_BENEFITS,
      element: <ManageBenefitsPage />,
      children: [
        {
          path: PATHS.BENEFITS,
          element: (
            <RoutePermissionGate>
              <BenefitsPage />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.MANAGE_BENEFITS +
            PATHS.BENEFITS +
            "/" +
            PATHS.VIEW +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AdminsAddEditBenefitsPage type="view" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.MANAGE_BENEFITS +
            PATHS.BENEFITS +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AdminsAddEditBenefitsPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.MANAGE_BENEFITS + PATHS.BENEFITS + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AdminsAddEditBenefitsPage type="add" />
            </RoutePermissionGate>
          ),
        },
      ],
    },
    // Support

    {
      path: PATHS.SUPPORT,
      element: <SupportManagement />,
      children: [
        {
          path: "",
          element: (
            <RoutePermissionGate>
              <Support />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.VIEW + "/:id",
          element: (
            <RoutePermissionGate>
              <TicketDetail />
            </RoutePermissionGate>
          ),
        },
      ],
    },

    // Settings
    {
      path: PATHS.SETTINGS,
      element: <Settings />,
      children: [
        {
          path: PATHS.GENERAL_SETTINGS,
          element: (
            <RoutePermissionGate>
              <GeneralSettings />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.EMAIL_NOTIFICATIONS,
          element: (
            <RoutePermissionGate>
              <EmailNotifications />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.PAYMENT_GATEWAY,
          element: (
            <RoutePermissionGate>
              <PaymentGateway />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.SMTP_SMS_DETAILS,
          element: (
            <RoutePermissionGate>
              <SmtpSmsDetails />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.SOCIAL_MEDIA,
          element: (
            <RoutePermissionGate>
              <SocialMedia />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.LANGUAGE_MESSAGES,
          element: (
            <RoutePermissionGate>
              <LanguageMessages />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.LANGUAGE_MESSAGES + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddLanguageMessages type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.LANGAUGE_STATIC_LANG,
          element: (
            <RoutePermissionGate>
              <LangaugeStaticLang />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.LANGAUGE_STATIC_LANG + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddLanguageStaticLang type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: "",
          element: (
            <Navigate to={`${PATHS.SETTINGS}/${PATHS.GENERAL_SETTINGS}`} />
          ),
        },
        {
          path: PATHS.ANY,
          element: (
            <Navigate to={`${PATHS.SETTINGS}/${PATHS.GENERAL_SETTINGS}`} />
          ),
        },
      ],
    },
    // Clubs List
    {
      path: PATHS.CLUB,
      element: <ClubsManagement />,
      children: [
        {
          // index: true,
          path: PATHS.CLUB,
          element: (
            <RoutePermissionGate>
              <ClubsListPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CLUB + "/" + PATHS.VIEW + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <AdminClubDetailPage />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.CLUB +
            "/" +
            PATHS.CLUB_ADMIN_LIST +
            "/" +
            PATHS.VIEW +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <ClubAdminDetailsPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CLUB + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <ClubAddEditPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CLUB + "/" + PATHS.CLUB_ADMIN_LIST + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <ClubAddEditPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CLUB + "/" + PATHS.EDIT + "/" + ":id" + "/" + ":url",
          element: (
            <RoutePermissionGate>
              <ClubAddEditPage type="edit" />
            </RoutePermissionGate>
          ),
        },
        {
          // index: true,
          path: PATHS.CLUB + "/" + PATHS.CLUBS_POSTS_LIST + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <ClubsPostsListPage />
            </RoutePermissionGate>
          ),
        },
        {
          // index: true,
          path:
            PATHS.CLUB +
            "/" +
            PATHS.CLUBS_POSTS_LIST +
            "/" +
            PATHS.CREATE +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditClubsPostsPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.CLUB +
            "/" +
            PATHS.CLUBS_POSTS_LIST +
            "/" +
            PATHS.EDIT +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <AddEditClubsPostsPage type="edit" />
            </RoutePermissionGate>
          ),
        },

        {
          path: "",
          element: <Navigate to={`${PATHS.CLUB}`} />,
        },
        {
          path: PATHS.ANY,
          element: <Navigate to={`${PATHS.CLUB}`} />,
        },
      ],
    },
    // Common Pages
    {
      path: PATHS.FourZeroFour,
      element: <FourZeroFourPage />,
    },
    {
      path: PATHS.THANKYOU,
      element: <ThankyouPage />,
    },
    {
      path: PATHS.COMING_SOON,
      element: <ComingSoonPage />,
    },
    // My Profile
    {
      path: PATHS.MY_PROFILE,
      element: <MyProfile />,
    },
    {
      path: PATHS.EDIT_MY_PROFILE,
      element: <EditMyProfile />,
    },
    {
      path: PATHS.CHANGE_PASSWORD,
      element: <ChangePasswordPage />,
    },

    //manage Promotions
    {
      path: PATHS.PROMOTION,
      element: <PromotionManagement />,
      children: [
        {
          path: PATHS.PROMOTION,
          element: (
            <RoutePermissionGate>
              <PromotionListPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.PROMOTION + "/" + PATHS.CREATE,
          element: (
            <RoutePermissionGate>
              <AddNewPromotionPage type="add" />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.PROMOTION + "/" + PATHS.EDIT + "/" + ":id",
          element: (
            <RoutePermissionGate>
              <EditAdminPromotions type="edit" />
            </RoutePermissionGate>
            // <RoutePermissionGate>
            //   <AddNewPromotionPage type="edit" />
            // </RoutePermissionGate>
          ),
        },

        // {
        //   path: PATHS.PROMOTION + "/" + PATHS.CREATE,
        //   element: (
        //     <RoutePermissionGate>
        //       <AddNewPromotionPage />
        //     </RoutePermissionGate>
        //   ),
        // },
        {
          path:
            PATHS.PROMOTION +
            PATHS.PROMOTION_DETAILS +
            "/" +
            PATHS.VIEW +
            "/:id",
          element: (
            <RoutePermissionGate>
              <PromotionDetailsPage />
            </RoutePermissionGate>
          ),
        },
      ],
    },
    //Reports
    {
      path: PATHS.REPORTS,
      element: <SuperAdmminReports />,
      children: [
        {
          path: PATHS.REPORTS + "/" + PATHS.ADMIN_MONITORING,
          element: (
            <RoutePermissionGate>
              <AdminMonitoringReportPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.REPORTS + "/" + PATHS.SUPER_USER_REPORT,
          element: (
            <RoutePermissionGate>
              <UserReportPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.REPORTS + "/" + PATHS.SUPER_CLUB_REPORT,
          element: (
            <RoutePermissionGate>
              <ClubReportPage />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.REPORTS + "/" + PATHS.SUPER_BRAND_REPORT,
          element: (
            <RoutePermissionGate>
              <BrandReportPage />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.REPORTS +
            "/" +
            PATHS.SUPER_CLUB_REPORT +
            "/" +
            PATHS.CLUB_STATS_DETAILS +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <ClubStatsDetailsPage />
            </RoutePermissionGate>
          ),
        },
        {
          path:
            PATHS.REPORTS +
            "/" +
            PATHS.SUPER_BRAND_REPORT +
            "/" +
            PATHS.BRAND_STATS_DETAILS +
            "/" +
            ":id",
          element: (
            <RoutePermissionGate>
              <BrandStatsDeatilsPage />
            </RoutePermissionGate>
          ),
        },
      ],
    },
    {
      path: PATHS.SUBSCRIBERS_LIST,
      element: (
        // <RoutePermissionGate>
        <BrandSubscriberList />
        // </RoutePermissionGate>
      ),
    },
    // club Admin Reports
    {
      path: PATHS.CLUB_ADMIN_REPORTS,
      element: <ClubAdminReportPage />,
      children: [
        {
          path: PATHS.CLUB_ADMIN_REPORTS + PATHS.CLUB_USER_REPORTS,
          element: (
            <RoutePermissionGate>
              <ClubUserReports />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.CLUB_ADMIN_REPORTS + PATHS.CLUB_MONITOR_REPORTS,
          element: (
            <RoutePermissionGate>
              <ClubMonitoringReports />
            </RoutePermissionGate>
          ),
        },
      ],
    },
    // club Admin Resports
    {
      path: PATHS.BRAND_ADMIN_REPORTS,
      element: <BrandReportManagement />,
      children: [
        {
          path: PATHS.BRAND_ADMIN_REPORTS + PATHS.BRAND_MONITOR_REPORTS,
          element: (
            <RoutePermissionGate>
              <BrandMonitoringReports />
            </RoutePermissionGate>
          ),
        },
        {
          path: PATHS.BRAND_ADMIN_REPORTS + PATHS.BRAND_USER_REPORTS,
          element: (
            <RoutePermissionGate>
              <BrandUserReports />
            </RoutePermissionGate>
          ),
        },
      ],
    },
    // UI Kit
    {
      path: PATHS.UI_KIT,
      element: (
        <UiKitLayout>
          <UiKit />
        </UiKitLayout>
      ),
      exact: true,
      children: [
        {
          path: PATHS.TYPOGRAPHY,
          element: <UiTypography />,
        },
        {
          path: PATHS.COLORS,
          element: <UiColors />,
        },
        {
          path: PATHS.FORMS,
          element: <UiForms />,
        },
        {
          path: PATHS.CARDS,
          element: <UiCards />,
        },
        {
          path: PATHS.BLOCKS,
          element: <UiBlocks />,
        },
        {
          path: PATHS.ANY,
          element: <Navigate to={PATHS.UI_KIT} />,
        },
      ],
    },
  ],
};

const AuthenticationRoutes = {
  path: PATHS.DEFAULT,
  element: (
    <GuestRoute>
      <AuthLayout />
    </GuestRoute>
  ),
  children: [
    {
      path: PATHS.DEFAULT,
      element: <Login />,
    },
    {
      path: PATHS.REGISTRATION + "/" + ":type",
      element: <Registration />,
    },

    {
      path: PATHS.FORGOT_PASSWORD,
      element: <ForgotPassword />,
    },
    {
      path: PATHS.RESET_PASSWORD,
      element: <ResetPassword />,
    },
  ],
};

const deleteUserRoutes = {
  path: PATHS.DELETE_USER,
  element: <DeleteUser />,
};

/**
 * @params {boolean}
 * @return {Array} of all paths & routes
 */
export const getRoutes = () => [
  AuthenticationRoutes,
  deleteUserRoutes,
  MainRoutes,
  {
    path: PATHS.ANY,
    element: <FourZeroFourPage />,
  },
];
